import { render, staticRenderFns } from "./newsPage.vue?vue&type=template&id=545b091a&scoped=true"
import script from "./newsPage.vue?vue&type=script&lang=js"
export * from "./newsPage.vue?vue&type=script&lang=js"
import style0 from "./newsPage.vue?vue&type=style&index=0&id=545b091a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545b091a",
  null
  
)

export default component.exports